import * as ng from 'angular';

export default (module: ng.IModule) => {
    module.component('tyPostInputBox', {
        bindings: {
            onPaste: '&?',
            onChange: '&?',
            value: '<?',
        },
        template: require('./post-input-box.component.html').default,
        controller: PostInputBoxCtrl,
    });
};

class PostInputBoxCtrl implements ng.IComponentController {
    static $inject = [];

    private onPaste?: (args: { $event: ng.IAngularEvent }) => void;
    private onChange?: (args: { $event: ng.IAngularEvent }) => void;
    private value: string = '';

    constructor() {}

    $onInit() {}

    $onChanges(onChangesObj: ng.IOnChangesObject) {
        // on changes
    }

    $onDestroy() {
        // cleanup logic
    }
}
